import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  AssignClinicalTrialQuestionnaireAction,
  DeleteClinicalTrialQuestionnaireAction,
  FetchQuestionnairesAction,
  FetchQuestionnairesSuccessAction,
  QuestionnairesState, UnassignClinicalTrialQuestionnaireAction,
} from '@restore/questionnaires/questionnaires.types';

const initialState: QuestionnairesState = {
  loadingQuestionnaires: false,
  error: undefined,
  questionnaires: [],
  clinicalTrialQuestionnaires: [],
};

const { actReq, actReject, actResolve } =
  makeActionCreator<QuestionnairesState>();

export const questionnairesSlice = createSlice({
  name: 'questionnaires',
  initialState,
  reducers: {
    fetchQuestionnaires: actReq<FetchQuestionnairesAction['payload']>(),
    fetchQuestionnairesSuccess:
      actResolve<FetchQuestionnairesSuccessAction['payload']>('questionnaires'),
    fetchQuestionnairesFailure: actReject('error'),
    fetchClinicalTrialQuestionnaires: actReq('loadingQuestionnaires'),
    fetchClinicalTrialQuestionnairesSuccess: actResolve<
      FetchQuestionnairesSuccessAction['payload']
    >('clinicalTrialQuestionnaires', 'loadingQuestionnaires'),
    fetchClinicalTrialQuestionnairesFailure: actReject(
      'error',
      'loadingQuestionnaires'
    ),
    addClinicalTrialQuestionnaireAction: actReq(),
    addClinicalTrialQuestionnaireSuccessAction: actResolve(),
    addClinicalTrialQuestionnaireFailureAction: actReject('error'),
    deleteClinicalTrialQuestionnaireAction:
      actReq<DeleteClinicalTrialQuestionnaireAction['payload']>(),
    deleteClinicalTrialQuestionnaireSuccessAction: actResolve(),
    deleteClinicalTrialQuestionnaireFailureAction: actReject('error'),
    assignClinicalTrialQuestionnaireAction:
      actReq<AssignClinicalTrialQuestionnaireAction['payload']>(),
    assignClinicalTrialQuestionnaireSuccessAction: actResolve(),
    assignClinicalTrialQuestionnaireFailureAction: actReject('error'),
    unassignClinicalTrialQuestionnaireAction:
      actReq<UnassignClinicalTrialQuestionnaireAction['payload']>(),
    unassignClinicalTrialQuestionnaireSuccessAction: actResolve(),
    unassignClinicalTrialQuestionnaireFailureAction: actReject('error'),
  },
});

export const actions = {
  ...questionnairesSlice.actions,
};

export const useQuestionnairesSlice = createSliceHook(
  questionnairesSlice.name,
  actions
);
